import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowUpRight, Menu, X } from 'lucide-react';
import { botSettingsAPI } from '../utils/api';
import { trackBotClick } from './AnalyticsTracker';

const fallbackBot = {
  telegram_enabled: true,
  telegram_url: 'https://t.me/lngaua_bot',
  whatsapp_enabled: false,
  whatsapp_url: ''
};

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [botSettings, setBotSettings] = useState(fallbackBot);
  const location = useLocation();

  useEffect(() => {
    botSettingsAPI.get()
      .then(({ data }) => setBotSettings({ ...fallbackBot, ...data }))
      .catch(() => setBotSettings(fallbackBot));
  }, []);

  useEffect(() => setIsMenuOpen(false), [location.pathname]);

  const navLinks = [
    { href: '/', label: 'Главная' },
    { href: '/tariffs', label: 'Тарифы' },
    { href: '/blog', label: 'Блог' },
    { href: '/partner-program', label: 'Партнёрам' },
    { href: '/support', label: 'Поддержка' }
  ];

  const openBot = async () => {
    const isTelegram = botSettings.telegram_enabled !== false;
    const url = isTelegram
      ? botSettings.telegram_url || fallbackBot.telegram_url
      : botSettings.whatsapp_url;

    await trackBotClick(isTelegram ? 'telegram' : 'whatsapp');
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <header className="nocturne-header">
      <div className="nocturne-nav">
        <Link to="/" className="nocturne-brand" aria-label="LNG AUA — на главную">
          <span className="nocturne-orbit" aria-hidden="true" />
          <span>LNG<span>AUA</span></span>
        </Link>

        <nav className="nocturne-links" aria-label="Основная навигация">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={location.pathname === link.href ? 'is-active' : ''}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <button className="nocturne-button primary desktop-cta" onClick={openBot}>
          Открыть бота <ArrowUpRight size={16} />
        </button>

        <button
          type="button"
          className="nocturne-menu-button"
          aria-label={isMenuOpen ? 'Закрыть меню' : 'Открыть меню'}
          aria-expanded={isMenuOpen}
          onClick={() => setIsMenuOpen((value) => !value)}
        >
          {isMenuOpen ? <X /> : <Menu />}
        </button>
      </div>

      {isMenuOpen && (
        <div className="nocturne-mobile-menu">
          {navLinks.map((link) => (
            <Link key={link.href} to={link.href}>{link.label}</Link>
          ))}
          <button className="nocturne-button primary" onClick={openBot}>
            Открыть бота <ArrowUpRight size={16} />
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;
